<app-mobile-filter-magic-cont
  *ngIf="isMobile; else desktop"
  [hasFilterSelected]="someFilterSelected"
  [heightClass]="modalHeight"
  (clear)="clearFilterAndResults()">
  <ng-container body="body" *ngTemplateOutlet="filters"></ng-container>
</app-mobile-filter-magic-cont>

<ng-container *ngIf="notifyAlertCreated">
  <app-alert-created-edited-modal
    [isCreated]="true"
    (toggleNotification)="toggleAlertCreated()">
  </app-alert-created-edited-modal>
</ng-container>

<ng-template #filters>
  <ng-container *ngIf="showBtnAlerts$ | async">
    <div class="alerts-container">
      <img class="logo" loading="lazy" [src]="alertImageNotification | ImageCdn">
      <div class="alerts-header">
        <span class="title">{{'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.MIN_TITLE' | transloco}}</span>
        <span class="description" *ngIf="(activateAlerts$ | async) === false">
          {{'GENERAL_WIDGET_MODULE.ALERTS.CARD_DESCRIPTION' | transloco}}
        </span>
        <span class="description" *ngIf="activateAlerts$ | async">
          {{'GENERAL_WIDGET_MODULE.ALERTS.CARD_DESCRIPTION_EXIST_ALERT' | transloco}}
        </span>
      </div>
      <div class="alerts-body">
        <div class="alerts-price">
          <span class="info">
            {{'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.PRICE_PLACEHOLDER' | transloco}}:
          </span>
          <span class="price" *ngIf="(activateAlerts$ | async) === false">
            {{ (maxPriceAlert$ | async) | currencyFormat: currencyCode }}
          </span>
          <span class="price" *ngIf="(activateAlerts$ | async)">
            {{ (priceAlertSelected$ | async) | currencyFormat: currencyCode }}
          </span>
        </div>
        <div class="alerts-create">
          <ng-container *ngIf="activateAlerts$ | async; else createAlert">
            <app-ds-button
              [size]="alertButtonSize"
              [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.REMOVE' | transloco }"
              (clickEvent)="toggleConfirmDeleteAlert()">
            </app-ds-button>
          </ng-container>

          <ng-template #createAlert>
            <app-ds-button
              [size]="alertButtonSize"
              [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.SAVE' | transloco }"
              (clickEvent)="toggleShowCreateAlertForm()">
            </app-ds-button>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngFor="let item of (filters$ | async | airFiltersVm: (busCompaniesEntities$ | async) : isBuses); let i = index">
    <ng-container *ngIf="isSorter(item)">
      <div [style.order]="orderChecks(item, i)">
        <app-air-sorter-filter
          [index]="i"
          [sorterSelected]="orderCriteria$ | async"
          [orderCriteriaSectorNumber]="orderCriteriaSectorNumber$ | async"
          [orderDesc]="orderDesc$ | async"
          (sortFlights)="sorting($event)"
          [departureCriteria]="getCriteria(item.type, departureType)"
          [returnCriteria]="getCriteria(item.type, returnType)"
          [options]="item"
          [isMobile]="isMobile">
        </app-air-sorter-filter>
      </div>
    </ng-container>
    <ng-container *ngIf="isCheckboxFilter(item)">
      <div [style.order]="orderChecks(item, i)" *ngIf="hasFilterAirline(item)">
        <app-checkbox-filter
          [options]="item.value"
          [pickedCheckboxes]="pickedCheckboxes"
          [type]="item.type"
          [index]="i"
          [isMobile]="isMobile"
          [label]="getItemLabel(item.type)"
          [isOpenBox]="true"
          (filter)="searchFlightsWithFilter($event)">
        </app-checkbox-filter>
      </div>
    </ng-container>
    <ng-container *ngIf="isSectionCheckBoxFilter(item)">
      <div [style.order]="i - 1" class="sector-departure">
        <app-sector-checkbox-filter
          [isBuses]="isBuses"
          [tripType]="1"
          [pickedCheckboxes]="pickedAirportsCheckboxes"
          [options]="item.value"
          [type]="item.type"
          [label]="getItemLabel(item.type)"
          [departureCriteria]="getCriteria(item.type, departureType)"
          [returnCriteria]="getCriteria(item.type, returnType)"
          [index]="i"
          [isMobile]="isMobile"
          [isOpenBox]="true"
          (filter)="searchFlightsWithFilter($event)">
        </app-sector-checkbox-filter>
      </div>
      <div [style.order]="i + 1" class="sector-return">
        <app-sector-checkbox-filter
          [isBuses]="isBuses"
          [tripType]="2"
          [pickedCheckboxes]="pickedAirportsCheckboxes"
          [options]="item.value"
          [type]="item.type"
          [label]="getItemLabel(item.type)"
          [departureCriteria]="getCriteria(item.type, departureType)"
          [returnCriteria]="getCriteria(item.type, returnType)"
          [index]="i"
          [isMobile]="isMobile"
          [isOpenBox]="true"
          (filter)="searchFlightsWithFilter($event)">
        </app-sector-checkbox-filter>
      </div>
    </ng-container>
    <ng-container *ngIf="isRangeFilter(item)">
      <ng-container *ngIf="valuesIsArray(item); else simpleRange">
        <ng-container *ngFor="let range of item.value, index as rangeIndex">
          <div [style.order]="i">
            <ng-container *ngIf="showRangeFilters; else rangeInput">
              <app-range-box-filter
                [isOpenBox]="true"
                [type]="item.type"
                [pickedRanges]="pickedRanges$ | async"
                [widgets]="rangeFilter$(item.type, range.SectorNumber) | async"
                [sector]="range.SectorNumber"
                [label]="getItemLabel(item.type) | transloco: { filterCriteria: getCriteria(item.type, range?.SectorNumber) }"
                (values)="applyRangeFilter(item.type, range, $event)">
              </app-range-box-filter>
            </ng-container>
            <ng-template #rangeInput>
              <app-range-input-filter
                [index]="i + '' + rangeIndex"
                [isOpenBox]="true"
                [min]="range.From"
                [max]="range.To"
                [type]="item.type"
                [rangeType]="range.RangeType"
                [pickedRanges]="pickedRanges$ | async"
                [sector]="range.SectorNumber"
                [label]="getItemLabel(item.type) | transloco: { filterCriteria: getCriteria(item.type, range.SectorNumber) }"
                (values)="applyRangeFilter(item.type, range, $event)">
              </app-range-input-filter>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #simpleRange>
        <div [style.order]="i">
          <ng-container *ngIf="showRangeFilters; else simpleRangeInput">
            <app-range-box-filter
              [isOpenBox]="true"
              [type]="item.type"
              [pickedRanges]="pickedRanges$ | async"
              [widgets]="rangeFilter$(item.type) | async"
              [label]="getItemLabel(item.type) | transloco: { currency: currencyCode }"
              (values)="applyRangeFilter(item.type, item.value, $event)">
          </app-range-box-filter>
          </ng-container>
          <ng-template #simpleRangeInput>
            <app-range-input-filter 
              [index]="i"
              [isOpenBox]="true"
              [min]="item.value.From"
              [max]="item.value.To"
              [type]="item.type"
              [rangeType]="item.value.RangeType"
              [pickedRanges]="pickedRanges$ | async"
              [label]="getItemLabel(item.type) | transloco"
              (values)="applyRangeFilter(item.type, item.value, $event)">
            </app-range-input-filter>
          </ng-template>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
  
</ng-template>

<ng-template #desktop>
  <ng-container *ngTemplateOutlet="filters"></ng-container>

  <app-user-alerts-desktop [showAlertsManagement]="showAlertsManagement"
    (toggleAlertsManagement)="toggleDesktopAlertsManagement()" [priceParamCreation]="maxPriceAlert$ | async"
    [directOnlyParamCreation]="directOnly$ | async" [isCreateAlert]="isCreateAlertMode"
    [isDeleteAlertMode]="isDeleteAlertMode" [alertSelected]="alertSelected">
  </app-user-alerts-desktop>
</ng-template>